export const getLocationDisplayName = (location, intl) => {

  let fallbackLocation = '<unknown>';
  if (typeof intl === "object" && typeof intl.formatMessage === "function") {
    fallbackLocation = '<' + intl.formatMessage({ id: 'common.deleted' }).toLowerCase() + '>';
  }

  if (!location) return fallbackLocation;
  let name = [location.name]
  const getParentName = (location, name) => {
    name.push(location.name)
    if (location.parent_location) {
      getParentName(location.parent_location, name)
    }
  }
  if (location.parent_location) {
    getParentName(location.parent_location, name)
    name.reverse()
    if (name.length <= 3) {
      return name.join(', ')
    }
    if (name.length > 3) {
      let last = name.pop()
      return name[0] + ', ..., ' + name.pop() + ', ' + last
    }
  }

  return location.name
}

export const transformLocations = (locationsResponse) => {
  const createLocation = (location) => {
    let loc = { key: location.id, label: location.name, is_locked: !!location.is_locked }
    if (location.children) {
      loc.children = location.children.map((c) => {
        return createLocation(c)
      })
    }
    return loc
  }
  return locationsResponse.map((location) => {
    return createLocation(location)
  })
}
